import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/cat1.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-840cc030"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "navHeader"
};
var _hoisted_2 = {
  class: "header-left"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "首页"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_4 = [_hoisted_3];
var _hoisted_5 = {
  class: "header-right"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  key: 0,
  class: "hot"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "hot-title"
  }, "热搜榜", -1
  /* HOISTED */
  );
});

var _hoisted_9 = {
  class: "hot-list"
};
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  class: "hot-item-index"
};
var _hoisted_12 = {
  class: "hot-item-name"
};
var _hoisted_13 = {
  class: "hot-name"
};
var _hoisted_14 = {
  class: "search-count"
};
var _hoisted_15 = {
  key: 0,
  class: "search-list"
};

var _hoisted_16 = /*#__PURE__*/_createTextVNode(" 搜索");

var _hoisted_17 = {
  class: "search-result"
};

var _hoisted_18 = /*#__PURE__*/_createTextVNode("相关的结果 ");

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-navbar_icon_right"
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_20 = {
  class: "search-type"
};
var _hoisted_21 = {
  key: 0,
  class: "search-music"
};

var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "type-title"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-music"
  }), /*#__PURE__*/_createElementVNode("span", null, "单曲")], -1
  /* HOISTED */
  );
});

var _hoisted_23 = ["onClick"];
var _hoisted_24 = ["innerHTML"];

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "line"
  }, "-", -1
  /* HOISTED */
  );
});

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "slash"
  }, "/", -1
  /* HOISTED */
  );
});

var _hoisted_27 = {
  key: 1,
  class: "search-songer"
};

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "type-title"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-user2"
  }), /*#__PURE__*/_createElementVNode("span", null, "歌手")], -1
  /* HOISTED */
  );
});

var _hoisted_29 = ["onClick"];
var _hoisted_30 = ["innerHTML"];
var _hoisted_31 = {
  key: 2,
  class: "search-album"
};

var _hoisted_32 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "type-title"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-album-line"
  }), /*#__PURE__*/_createElementVNode("span", null, "专辑")], -1
  /* HOISTED */
  );
});

var _hoisted_33 = ["onClick"];
var _hoisted_34 = ["innerHTML"];

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "line"
  }, "-", -1
  /* HOISTED */
  );
});

var _hoisted_36 = {
  key: 3,
  class: "search-sheet"
};

var _hoisted_37 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "type-title"
  }, [/*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-music-list"
  }), /*#__PURE__*/_createElementVNode("span", null, "歌单")], -1
  /* HOISTED */
  );
});

var _hoisted_38 = ["onClick"];
var _hoisted_39 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_tooltip = _resolveComponent("el-tooltip");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_image = _resolveComponent("el-image");

  var _component_Loading = _resolveComponent("Loading");

  var _component_SearchVue = _resolveComponent("SearchVue");

  var _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, null, {
    default: _withCtx(function () {
      return [_createCommentVNode(" 左边 "), _createVNode(_component_el_col, {
        span: 4
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createCommentVNode(" 图片提示 "), _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "light",
            content: "回到首页",
            placement: "right"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                class: "home-img",
                onClick: _cache[0] || (_cache[0] = //@ts-ignore
                function () {
                  return _ctx.homeClick && _ctx.homeClick.apply(_ctx, arguments);
                })
              }, _hoisted_4)];
            }),
            _: 1
            /* STABLE */

          }), _createElementVNode("div", null, [_createCommentVNode(" 后退 "), _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "light",
            content: "后退",
            placement: "left"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("i", {
                class: "iconfont icon-common_icon_left",
                onClick: _cache[1] || (_cache[1] = //@ts-ignore
                function () {
                  return _ctx.backClick && _ctx.backClick.apply(_ctx, arguments);
                })
              })];
            }),
            _: 1
            /* STABLE */

          }), _createCommentVNode(" 前进 "), _createVNode(_component_el_tooltip, {
            class: "box-item",
            effect: "light",
            content: "前进",
            placement: "right"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("i", {
                class: "iconfont icon-navbar_icon_right",
                onClick: _cache[2] || (_cache[2] = //@ts-ignore
                function () {
                  return _ctx.forwardClick && _ctx.forwardClick.apply(_ctx, arguments);
                })
              })];
            }),
            _: 1
            /* STABLE */

          })])])];
        }),
        _: 1
        /* STABLE */

      }), _createCommentVNode(" 右边 "), _createVNode(_component_el_col, {
        span: 20
      }, {
        default: _withCtx(function () {
          return [_createCommentVNode(" 导航 "), _createElementVNode("div", _hoisted_5, [_createCommentVNode(" 每个导航item "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerRouter, function (item) {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['nav-right-box', _ctx.isRouter === item.router ? 'active' : '']),
              key: item.router,
              onClick: function onClick($event) {
                return _ctx.headerClick(item.router);
              }
            }, [_createElementVNode("span", null, _toDisplayString(item.title), 1
            /* TEXT */
            )], 10
            /* CLASS, PROPS */
            , _hoisted_6)), [[_vShow, _ctx.isHeaderRight]]);
          }), 128
          /* KEYED_FRAGMENT */
          )), _createCommentVNode(" 搜索功能 "), _createVNode(_component_SearchVue, {
            ref: "refSearchVue",
            onHandleChangeValue: _ctx.handleChangeValue
          }, {
            box1: _withCtx(function () {
              return [_ctx.searchHot.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createCommentVNode(" 每个item项 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchHot, function (item, index) {
                return _openBlock(), _createElementBlock("div", {
                  class: "hot-item",
                  key: index,
                  onClick: function onClick($event) {
                    return _ctx.hotClick(item.searchWord);
                  }
                }, [_createCommentVNode(" 索引 "), _createElementVNode("div", _hoisted_11, _toDisplayString(index + 1), 1
                /* TEXT */
                ), _createCommentVNode(" 名字和热图片 "), _createElementVNode("div", _hoisted_12, [_createCommentVNode(" 名字 "), _createElementVNode("span", _hoisted_13, _toDisplayString(item.searchWord), 1
                /* TEXT */
                ), _createCommentVNode(" 图片 "), _withDirectives(_createVNode(_component_el_image, {
                  class: "icon-hot",
                  src: item.iconUrl
                }, null, 8
                /* PROPS */
                , ["src"]), [[_vShow, item.iconType]])]), _createCommentVNode(" 热搜值 "), _createElementVNode("div", _hoisted_14, _toDisplayString(item.score), 1
                /* TEXT */
                )], 8
                /* PROPS */
                , _hoisted_10);
              }), 128
              /* KEYED_FRAGMENT */
              ))])])) : (_openBlock(), _createBlock(_component_Loading, {
                key: 1
              }))];
            }),
            box2: _withCtx(function () {
              var _ctx$searchInfo, _ctx$searchInfo2, _ctx$searchInfo3, _ctx$searchInfo4, _ctx$searchInfo5, _ctx$searchInfo6, _ctx$searchInfo7, _ctx$searchInfo8;

              return [Object.keys(_ctx.searchInfo).length ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createCommentVNode(" 搜索结果标题 "), _createElementVNode("div", {
                class: "search-all",
                onClick: _cache[3] || (_cache[3] = //@ts-ignore
                function () {
                  return _ctx.resultClick && _ctx.resultClick.apply(_ctx, arguments);
                })
              }, [_createElementVNode("span", null, [_hoisted_16, _createElementVNode("span", _hoisted_17, "“" + _toDisplayString(_ctx.iptValue) + "”", 1
              /* TEXT */
              ), _hoisted_18]), _hoisted_19]), _createCommentVNode(" 搜索类型 "), _createElementVNode("div", _hoisted_20, [_createCommentVNode(" 单曲 "), (_ctx$searchInfo = _ctx.searchInfo) !== null && _ctx$searchInfo !== void 0 && _ctx$searchInfo.songs ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_hoisted_22, _createCommentVNode(" 单曲item "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx$searchInfo2 = _ctx.searchInfo) === null || _ctx$searchInfo2 === void 0 ? void 0 : _ctx$searchInfo2.songs, function (song) {
                return _openBlock(), _createElementBlock("div", {
                  class: "item music-item linelittle",
                  key: song.id,
                  onClick: function onClick($event) {
                    return _ctx.playerClick(song.id);
                  }
                }, [_createCommentVNode(" 单曲名 "), _createElementVNode("span", {
                  class: "music-name",
                  innerHTML: _ctx.lightKeyword(song.name, _ctx.iptValue)
                }, null, 8
                /* PROPS */
                , _hoisted_24), _hoisted_25, _createCommentVNode(" 歌手 "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(song.artists, function (songer) {
                  return _openBlock(), _createElementBlock("span", {
                    class: "music-songers",
                    key: songer.id
                  }, [_createElementVNode("span", null, _toDisplayString(songer.name), 1
                  /* TEXT */
                  ), _hoisted_26]);
                }), 128
                /* KEYED_FRAGMENT */
                ))], 8
                /* PROPS */
                , _hoisted_23);
              }), 128
              /* KEYED_FRAGMENT */
              ))])) : _createCommentVNode("v-if", true), _createCommentVNode(" 歌手 "), (_ctx$searchInfo3 = _ctx.searchInfo) !== null && _ctx$searchInfo3 !== void 0 && _ctx$searchInfo3.artists ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createCommentVNode(" 标题 "), _hoisted_28, _createCommentVNode(" 歌手item "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx$searchInfo4 = _ctx.searchInfo) === null || _ctx$searchInfo4 === void 0 ? void 0 : _ctx$searchInfo4.artists, function (artist) {
                return _openBlock(), _createElementBlock("div", {
                  class: "item artists-item linelittle",
                  key: artist.id,
                  onClick: function onClick($event) {
                    return _ctx.songerClick(artist.id);
                  }
                }, [_createCommentVNode(" 歌手名 "), _createElementVNode("span", {
                  class: "artists-name",
                  innerHTML: _ctx.lightKeyword(artist.name, _ctx.iptValue)
                }, null, 8
                /* PROPS */
                , _hoisted_30)], 8
                /* PROPS */
                , _hoisted_29);
              }), 128
              /* KEYED_FRAGMENT */
              ))])) : _createCommentVNode("v-if", true), _createCommentVNode(" 专辑 "), (_ctx$searchInfo5 = _ctx.searchInfo) !== null && _ctx$searchInfo5 !== void 0 && _ctx$searchInfo5.albums ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createCommentVNode(" 标题 "), _hoisted_32, _createCommentVNode(" 专辑item "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx$searchInfo6 = _ctx.searchInfo) === null || _ctx$searchInfo6 === void 0 ? void 0 : _ctx$searchInfo6.albums, function (album) {
                return _openBlock(), _createElementBlock("div", {
                  class: "item music-item linelittle",
                  key: album.id,
                  onClick: function onClick($event) {
                    return _ctx.albumClick(album.id);
                  }
                }, [_createCommentVNode(" 专辑名 "), _createElementVNode("span", {
                  class: "album-name",
                  innerHTML: _ctx.lightKeyword(album.name, _ctx.iptValue)
                }, null, 8
                /* PROPS */
                , _hoisted_34), _hoisted_35, _createCommentVNode(" 歌手 "), _createElementVNode("span", null, _toDisplayString(album.artist.name), 1
                /* TEXT */
                )], 8
                /* PROPS */
                , _hoisted_33);
              }), 128
              /* KEYED_FRAGMENT */
              ))])) : _createCommentVNode("v-if", true), _createCommentVNode(" 歌单 "), (_ctx$searchInfo7 = _ctx.searchInfo) !== null && _ctx$searchInfo7 !== void 0 && _ctx$searchInfo7.playlists ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createCommentVNode(" 标题 "), _hoisted_37, _createCommentVNode(" 歌单item "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx$searchInfo8 = _ctx.searchInfo) === null || _ctx$searchInfo8 === void 0 ? void 0 : _ctx$searchInfo8.playlists, function (sheet) {
                return _openBlock(), _createElementBlock("div", {
                  class: "item music-item linelittle",
                  key: sheet.id,
                  onClick: function onClick($event) {
                    return _ctx.sheetClick(sheet.id);
                  }
                }, [_createCommentVNode(" 歌单名 "), _createElementVNode("span", {
                  class: "sheet-name",
                  innerHTML: _ctx.lightKeyword(sheet.name, _ctx.iptValue)
                }, null, 8
                /* PROPS */
                , _hoisted_39)], 8
                /* PROPS */
                , _hoisted_38);
              }), 128
              /* KEYED_FRAGMENT */
              ))])) : _createCommentVNode("v-if", true)])])) : (_openBlock(), _createBlock(_component_Loading, {
                key: 1,
                loadTitle: "载入中或暂无数据..."
              }))];
            }),
            _: 1
            /* STABLE */

          }, 8
          /* PROPS */
          , ["onHandleChangeValue"])])];
        }),
        _: 1
        /* STABLE */

      })];
    }),
    _: 1
    /* STABLE */

  })]);
}